// Swipe rows with previous/next arrows: homepage reviews, product rows and Shop by category.
// The list is a CSS scroll-snap row (touch swiping and keyboard scrolling work without this);
// this adds the arrows, which page by however many whole cards are visible and disable at the ends.
// Markup: <home-slider> … <element data-slider-list> … {% render 'home-slider-controls' %} </home-slider>
class HomeSlider extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('[data-slider-list]');
    this.prev = this.querySelector('[data-slider-prev]');
    this.next = this.querySelector('[data-slider-next]');
    if (!this.list || !this.prev || !this.next) return;
    this.prev.addEventListener('click', () => this.page(-1));
    this.next.addEventListener('click', () => this.page(1));
    this.list.addEventListener('scroll', () => this.update(), { passive: true });
    window.addEventListener('resize', () => this.update());
    this.update();
  }

  page(direction) {
    const card = this.list.firstElementChild;
    const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
    const step = card ? card.offsetWidth + gap : this.list.clientWidth;
    const perView = Math.max(1, Math.floor((this.list.clientWidth + gap) / step));
    this.list.scrollBy({ left: direction * step * perView, behavior: 'smooth' });
  }

  update() {
    const max = this.list.scrollWidth - this.list.clientWidth;
    this.prev.disabled = this.list.scrollLeft <= 2;
    this.next.disabled = this.list.scrollLeft >= max - 2;
    // Hide the arrows when everything fits
    this.toggleAttribute('data-static', max <= 2);
  }
}

if (!customElements.get('home-slider')) customElements.define('home-slider', HomeSlider);
